var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text--primary"},[_c('span',{staticClass:"footer-text",domProps:{"innerHTML":_vm.getFormatedHtml(_vm.selectedInitiative.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }